import Vue from 'vue'
import { omitBy, isNil } from 'lodash'

export function buildUrl({ path, searchParams }) {
  const search = new URLSearchParams(omitBy(searchParams, isNil)).toString()
  return search ? `${path}?${search}` : path
}

export const EventBus = new Vue()
